<template>
	<sidebar :title="selectedSubRetailerUser && selectedSubRetailerUser.subRetailerUserID
		!= 0 ? `Edit Agent: ${selectedSubRetailerUser.name}`
		: 'Add Agent'" :show="showSubRetailerUserDetailSidebar" @on-close="close" size="sm">
		<template v-slot:body>
			<form @submit.prevent="submitSubRetailerUserAccess" ref="subRetailerUserForm">
				<div class="row">
					<div class="col">
						<div class="form-group">
							<label>Name</label>
							<div class="mb-3">
								<input type="text" class="form-control" v-model="selectedSubRetailerUser.name"
									:disabled="subRetailerUsersSubmitting" required />
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="form-group">
							<label>Email</label>
							<div class="mb-3">
								<input type="text" class="form-control" v-model="selectedSubRetailerUser.email"
									:disabled="subRetailerUsersSubmitting" required />
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="form-group">
							<label>Username</label>
							<div class="mb-3">
								<input type="text" class="form-control" v-model="selectedSubRetailerUser.username"
									:disabled="subRetailerUsersSubmitting" required />
							</div>
						</div>
					</div>
				</div>
				<div class="row text-center">
					<div class="col">
						<button type="submit" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0"
							:disabled="subRetailerUsersSubmitting">
							<div class="spinner-border spinner-border-sm" role="status"
								v-if="subRetailerUsersSubmitting">
								<span class="sr-only">Loading...</span>
							</div>
							Submit
						</button>
					</div>
				</div>
			</form>

			<div v-if="selectedSubRetailerUser.subRetailerUserID != 0" class="mt-4">
				<button type="button" class="btn btn-outline-secondary w-100"
					@click="showPasswordForm = !showPasswordForm">
					{{ showPasswordForm ? 'Cancel Password Change' : 'Change Password' }}
				</button>
				<div v-if="showPasswordForm" class="mt-3">
					<input type="password" class="form-control mb-2" placeholder="New Password"
						v-model="passwordForm.newPassword" />
					<input type="password" class="form-control mb-2" placeholder="Confirm Password"
						v-model="passwordForm.confirmPassword" />
					<button class="btn btn-info w-100" @click="changePassword">Submit Password Change</button>
				</div>
			</div>
		</template>
	</sidebar>

	<GlobalModal :show="modal.show" :type="modal.type" :title="modal.title" :message="modal.message"
		@close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import GlobalModal from "@/components/GlobalModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
	components: { sidebar, GlobalModal },
	data() {
		return {
			showPasswordForm: false,
			passwordForm: { newPassword: '', confirmPassword: '' },
			modal: { show: false, type: 'success', title: '', message: '' }
		};
	},
	computed: {
		...mapState({
			selectedSubRetailer: state => state.retailerController.selectedSubRetailer,
			selectedSubRetailerUser: state => state.retailerController.selectedSubRetailerUser,
			subRetailerUsersSubmitting: state => state.retailerController.subRetailerUsersSubmitting,
			showSubRetailerUserDetailSidebar: state => state.retailerController.showSubRetailerUserDetailSidebar
		})
	},
	methods: {
		...mapMutations({
			setShowSubRetailerUserDetailSidebar: "retailerController/SET_ShowSubRetailerUserDetailSidebar",
			selectSubRetailerUser: "retailerController/SELECT_SubRetailerUser"
		}),
		...mapActions({
			getSubRetailerUsers: "retailerController/GetSubRetailerUsers",
			addSubRetailerUsers: "retailerController/AddSubRetailerUsers",
			updateSubRetailerUserDetails: "retailerController/UpdateSubRetailerUserDetails",
			changeSubRetailerUserPassword: "retailerController/ChangeSubRetailerUserPassword"
		}),
		close() {
			this.selectSubRetailerUser(null);
			this.setShowSubRetailerUserDetailSidebar(false);
		},
		async submitSubRetailerUserAccess() {
			const form = this.$refs.subRetailerUserForm;
			if (!form.checkValidity()) {
				form.reportValidity();
				return;
			}
			let result;
			if (this.selectedSubRetailerUser.subRetailerUserID != 0) {
				result = await this.updateSubRetailerUserDetails().catch(err => {
					this.showModal('error', 'Error', err.data?.ErrorMessage || 'Error Submitting User Details');
				});
				if (result) {
					this.showModal('success', 'Updated', 'User details updated successfully.');
				} else if (result === false) {
					this.showModal('error', 'Error', 'Error Submitting User Details');
				}
			} else {
				result = await this.addSubRetailerUsers().catch((error) => {
					const message = error?.data?.ErrorMessage || 'Unable to add user';
					this.showModal('error', 'Error', message);
				});
				if (result) {
					this.showModal('success', `Temporary password: ${result}`, 'Press Confirm after saving the temporary password');
				}
			}
			if (result) {
				await this.getSubRetailerUsers();
				this.close();
			}
		},
		async changePassword() {
			if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
				return this.showModal('error', 'Mismatch', 'Passwords do not match.');
			}
			const payload = {
				subRetailerUserID: this.selectedSubRetailerUser.subRetailerUserID,
				newPassword: this.passwordForm.newPassword
			};
			await this.changeSubRetailerUserPassword(payload)
				.then(() => {
					this.showModal('success', 'Password Changed', 'Password has been updated.');
					this.showPasswordForm = false;
				})
				.catch(err => {
					this.showModal('error', 'Validation Error', err.data?.errors?.join('<br/>') || 'Unable to change password');
				});
		},
		showModal(type, title, message) {
			this.modal = { show: true, type, title, message };
		},
	}
};
</script>

<style scoped></style>
